import asset from './assets/geowealth.webp'

export default (props) => (
  <img
    src={asset}
    alt="GeoWealth"
    aria-hidden="true"
    width="194"
    height="45"
    {...props}
  />
)
